const modalsMobile = (state = {
        ModalComponent: null,
        modalComponentProps: {},
        modalContainerStyle: {}
}, action) => {
    switch (action.type) {
        case 'MODAL_MOBILE_SHOW_REQUESTED':
            return {
                ModalComponent: action.payload.ModalComponent,
                modalComponentProps: action.payload.modalComponentProps,
                modalContainerStyle: action.payload.modalContainerStyle
            };

        case 'MODAL_MOBILE_HIDE_REQUESTED':
            return {
                ModalComponent: null
            };

        default:
            return state;
    }
};

export default modalsMobile;
